const HREFLANG_ENVS = [
  { uk: 'https://policymogul.com', us: 'https://us.policymogul.com' },
  { uk: 'https://staging.policymogul.com', us: 'https://us-staging.policymogul.com' },
];

const injectHreflangTags = () => {
  const appUrl = import.meta.env.VITE_APP_APPURL;
  const env = HREFLANG_ENVS.find(({ uk, us }) => appUrl === uk || appUrl === us);
  if (!env) return;

  const pathname = window?.location?.pathname ?? '/';
  document.head.querySelectorAll('link[data-pm-hreflang]').forEach((el) => el.remove());

  [
    { hreflang: 'en-gb', href: `${env.uk}${pathname}` },
    { hreflang: 'en-us', href: `${env.us}${pathname}` },
    { hreflang: 'x-default', href: `${env.uk}${pathname}` },
  ].forEach(({ hreflang, href }) => {
    const link = document.createElement('link');
    link.rel = 'alternate';
    link.hreflang = hreflang;
    link.href = href;
    link.dataset.pmHreflang = 'true';
    document.head.appendChild(link);
  });
};

export default injectHreflangTags;
